import { useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  notificationName: string
  notificationType: string
  value: boolean
}

export function useUpdateCustomerNotifications() {
  return useMutation<unknown, unknown, MutationFnParams>({
    mutationFn: async ({ notificationName, notificationType, value }) => {
      const response = await fetcher(
        "/Customer/Notifications",
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            notificationName,
            notificationType,
            value,
          }),
        },
        { useAccessToken: true }
      )

      return response
    },
    onError: (error) => {
      console.log("error?", JSON.stringify(error))
    },
  })
}
